/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  CouponResponse,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Get coupon details
 */
export const getCoupon = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<CouponResponse>(
      {url: `/b2c/coupons/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCouponQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'b2c','coupons',id
    ] as const;
    }


export const getGetCouponQueryOptions = <TData = Awaited<ReturnType<typeof getCoupon>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCouponQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCoupon>>> = ({ signal }) => getCoupon(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>
}

export type GetCouponQueryResult = NonNullable<Awaited<ReturnType<typeof getCoupon>>>
export type GetCouponQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary Get coupon details
 */

export function useGetCoupon<TData = Awaited<ReturnType<typeof getCoupon>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCoupon>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCouponQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






